module.exports = __webpack_public_path__ + "posture/static/img/pelvis_lean_left.de9075d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/abnormal/pelvis_lean_left.png
// module id = uV2h
// module chunks = 1